import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '~/context/AuthProvider';
import { approveMedicalCenter } from '~/services/medical-centers';
import PrimaryButton from '../Common/PrimaryButton';
import SecondaryButton from '../Common/SecondaryButton';

const ApproveModal: React.FC<{
    name: string;
    id: number;
    setApproved: any;
    approved: boolean;
}> = ({ name, id, setApproved, approved }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const { person } = useAuth();
    const trigger = useRef<any>(null);
    const modal = useRef<any>(null);

    // close if the esc key is pressed
    useEffect(() => {
        const keyHandler = ({ keyCode }: KeyboardEvent) => {
            if (!modalOpen || keyCode !== 27) return;
            setModalOpen(false);
        };
        document.addEventListener('keydown', keyHandler);
        return () => document.removeEventListener('keydown', keyHandler);
    });

    const approve = () => {
        if (person?.id) {
            approveMedicalCenter(id, person?.id).then((res) => {
                if (res) {
                    setModalOpen(false);
                    setApproved(true);
                }
            });
        }
    };

    return (
        <div>
            <button
                ref={trigger}
                {...(!approved && { onClick: () => setModalOpen(!modalOpen) })}
                disabled={approved}
                className={`m-auto mr-3 rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 ${
                    approved
                        ? 'cursor-default border-[#6BB841] bg-[#6BB841] text-white'
                        : 'border-warning bg-warning text-black hover:border-[#e6f7f8] hover:bg-[#e6f7f8]'
                }`}
            >
                {approved ? 'Approved' : 'Approve'}
            </button>
            <div
                className={`fixed left-0 top-0 z-999999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5 ${
                    modalOpen ? 'block' : 'hidden'
                }`}
            >
                <div
                    ref={modal}
                    onFocus={() => setModalOpen(true)}
                    onBlur={() => setModalOpen(false)}
                    className='w-full max-w-142.5 rounded-lg bg-white px-8 py-12 text-center dark:bg-boxdark md:px-8 md:py-12'
                >
                    <h3 className='pb-2 text-left text-xl font-bold text-black dark:text-white sm:text-2xl'>
                        Approve Medical Center
                    </h3>
                    <p className='text-left'>
                        You are about to approve{' '}
                        <span className='font-bold'>{name}</span>. Doing so will
                        legitimize them in the database and confirm all
                        information entered here allowing their record to show
                        up for patients.
                    </p>
                    <br />
                    <p className='mb-10 text-left'>
                        Are you sure you want to verify them
                    </p>
                    <div className='-mx-3 flex flex-wrap gap-y-4'>
                        <div className='mx-3'>
                            <SecondaryButton
                                onClick={() => setModalOpen(false)}
                                title='Cancel'
                            />
                        </div>
                        <div className=''>
                            <PrimaryButton onClick={approve} title='Approve' />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ApproveModal;
